import { useNavigate } from "react-router-dom";
import { VARIANTS } from "../lib/data";
import { useCart } from "../context/CartContext";
import { useLang } from "../context/LanguageContext";
import { useTheme } from "../context/ThemeContext";
import { useImages } from "../context/ContentContext";
import { toast } from "sonner";

export function MobileStickyBar() {
  const { add } = useCart();
  const nav = useNavigate();
  const { t } = useLang();
  const { universe } = useTheme();
  const IMG = useImages();

  const variant = universe === "femme"
    ? {
        ...VARIANTS.single,
        key: "serum_femme",
        label: "Sérum Capillaire Femme",
        image: IMG.femmeOffer,
        universe: "femme",
      }
    : {
        ...VARIANTS.single,
        key: "serum_homme",
        label: "Sérum Capillaire Homme",
        image: IMG.offer,
        universe: "homme",
      };

  const handleAdd = () => {
    // Femme et Homme peuvent cohabiter dans le même panier.
    // CartContext gère l'ajout par lookup_key sans imposer de séparation de gamme.
    add(variant);
    toast.success(t("offer.added"));
    nav("/panier");
  };

  return (
    <div className="md:hidden fixed bottom-0 left-0 right-0 z-40 border-t px-4 py-3 flex items-center gap-3 backdrop-blur-xl" style={{ borderColor: "var(--lo-border-rose)", background: "color-mix(in srgb, var(--lo-bg) 92%, transparent)" }} data-testid="mobile-sticky-bar">
      <div className="leading-tight">
        <p className="text-[10px] uppercase tracking-widest" style={{ color: "var(--lo-muted)" }}>Sérum Capillaire</p>
        <p className="font-display text-xl" style={{ color: "var(--lo-rose-hi)" }}>{variant.unit.toFixed(2).replace(".", ",")} €</p>
      </div>
      <button className="btn-primary flex-1 h-12" onClick={handleAdd} data-testid="sticky-add-btn">
        {t("common.add_to_cart")}
      </button>
    </div>
  );
}
